export default __webpack_public_path__ + "static/media/caution-icon.60a53ce3.svg";